import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userSlice from './user/userSlice';
import locationSlice, { ILocationStoreState } from './location/locationSlice';
import WishlistsSlice, { IWishlistStore } from './wishlist/wishlistSlice';
import cartSlice, { TCartState } from './cart/cartSlice';
import SeoState from '@/store/seo/seoSlice';
import HaptikSlice from '@/store/haptik/haptikSlice';
import AppConfigSlice, { AppConfig } from '@/store/appConfig/appConfigSlice';
import { TUserState } from './user/userSlice';
import unlmtdCartSlice from './unlmtd/slices/cartSlice';
import planSlice from './unlmtd/slices/planConfigSlice';
import subscriptionSlice from './unlmtd/slices/subscriptionSlice';


export interface IStoreState {
  user: TUserState,
  location: ILocationStoreState;
  cart: TCartState;
  wishlist: IWishlistStore;
  seoData: {
    data: {
      title: string;
      description: string;
    };
  };
  routerConfig: {
    isHaptikEnabled: boolean;
  };
  appConfig: AppConfig;
}

const store = configureStore({
  reducer: { 
    user: userSlice, 
    cart: cartSlice, 
    location: locationSlice, 
    wishlist: WishlistsSlice, 
    seo: SeoState, 
    routerConfig: HaptikSlice, 
    appConfig: AppConfigSlice ,
    unlmtdCart: unlmtdCartSlice,
    plans: planSlice,
    subscription: subscriptionSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// For backward compatibility with your existing code
export type TAppDispatch = AppDispatch;
export type GroguState = RootState;
export type GroguDispatch = AppDispatch;
export type GroguThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;